import { render, staticRenderFns } from "./genedetail_trait.vue?vue&type=template&id=03abf18f&scoped=true&"
import script from "./genedetail_trait.vue?vue&type=script&lang=js&"
export * from "./genedetail_trait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03abf18f",
  null
  
)

export default component.exports